import { autoinject, observable, BindingEngine } from 'aurelia-framework';
import { BaseDevice } from "./base-device";
import { Device } from "../../../models/device";
import { Api } from "../../../services/api";
import { DigitalOutputToggleRequestViewModel } from "../../../models/digital-output-toggle-request-view-model";
import { Store } from "aurelia-store";
import { IState } from "../../../store/state";
import { Subscription, Observable } from 'rxjs';
import { MeasurementViewModel } from "../../../models/measurement-view-model";
import { AsEnumerable } from "linq-es2015/lib/linq";

@autoinject
export class UrsalinkUc1152 extends BaseDevice {


	@observable checked: boolean;
	disabled: boolean = false;
	suppressApiCall: boolean = false;

	constructor(store: Store<IState>, api: Api) {
		super(store, api);
	}

	bind(bindingContext: any, overrideContext: any) {
		this.subscription = this.store.state.subscribe((state) => {
			this.applicationState = state;
			if (this.device) {
				this.device = this.getDevice();
				if (this.device) {
					this.setChecked((this.device.data.digitalOutput === 1));
				}
			}
		});
		this.device = bindingContext.device;
	}

	unbind() {
		this.unsubscribe();
	}

	setChecked(value: boolean) {
		if (this.checked !== value) {
			this.suppressApiCall = true;
			this.checked = value;
		}
	}

	activate(device: Device) {
		this.device = device;
		this.setChecked((this.device.data ? this.device.data.digitalOutput === 1 : false));

		this.subscription = this.store.state.subscribe((state) => {
			this.applicationState = state;
			if (this.device) {
				const device = this.getDevice();
				if (device) {
					this.device = device;
					if (this.device) {
						this.setChecked((this.device.data.digitalOutput === 1));
					}
				}
			}
		});

			const metadata = this.device.metadata;
		//this.deviceObservable = this.store.state.pipe(state =>
		//	state.selectedLocations.find(l => l.id === metadata.locationId)
		//		.zones.find(z => z.id === metadata.zoneId)
		//		.structures.find(s => s.id === metadata.structureId)
		//		.devices.find(d => d.id === metadata.deviceId)
		// );
		//	this.deviceSubscription = this.deviceObservable.subscribe((dev) => {
		//		this.device = <Device>dev;
		//	});


	}

	toggleChecked() {
		this.checked = !this.checked;
	}


	async checkedChanged(newValue, oldValue) {

		// don't call to the API to change state if 'checked' was set 
		// programmatically
		if (this.suppressApiCall) {
			this.suppressApiCall = false;
			return;
		}

		this.disabled = true;
		const viewModel = new DigitalOutputToggleRequestViewModel();
		viewModel.deviceIds.push(this.device.deviceId);
		viewModel.state = newValue;
		
		const response = await this.api.toggleDigitalOutput(viewModel);
		if (response.success === false) {
			this.setChecked(oldValue);
			//this.checked = oldValue;
		}

		// The UC1152 units need about 10 seconds in between direct commands to change state correctly, 
		// so disable the control for 10 seconds to prevent the user from getting the 
		// UI out of sync with the UC1152.
		setTimeout(() => { this.disabled = false }, 10000);
	}


	async digitalOutputChanged(newValue, oldValue) {
		if (this.checked !== newValue) {
			this.setChecked(newValue);
		}
	}


	
}